var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoContentsSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AB3A7E64-7B0A-4049-90B8-5B6137518672") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 0 0.200000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Common",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "(A.0.5.1)-GNB_\\uC0AC\\uC6A9\\uC790-\\uC815\\uBCF4-\\uD31D\\uC5C5",
    transform: "translate(-1670.000000, -573.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Info_open-:-domain",
    transform: "translate(1650.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico/contents/setting",
    transform: "translate(0.000000, 172.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.214286, 3.214286)",
    stroke: "#B6BFCE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2064086,6.35271429 C10.2302006,6.16757143 10.2480447,5.98242857 10.2480447,5.78571429 C10.2480447,5.589 10.2302006,5.40385714 10.2064086,5.21871429 L11.4614412,4.26407143 C11.5744537,4.17728571 11.6041938,4.02107143 11.5328175,3.89378571 L10.3432131,1.89192857 C10.2718368,1.76464286 10.1112402,1.71835714 9.98038371,1.76464286 L8.49932618,2.34321429 C8.19002903,2.11178571 7.85693978,1.92085714 7.49411043,1.77621429 L7.26808558,0.243 C7.25024152,0.104142857 7.12533305,0 6.9766325,0 L4.59742361,0 C4.44872305,0 4.32381459,0.104142857 4.30597052,0.243 L4.07994568,1.77621429 C3.71711632,1.92085714 3.38402708,2.11757143 3.07472992,2.34321429 L1.59367239,1.76464286 C1.45686788,1.71257143 1.3022193,1.76464286 1.23084304,1.89192857 L0.041238592,3.89378571 C-0.0360856968,4.02107143 -0.000397563466,4.17728571 0.112614859,4.26407143 L1.36764755,5.21871429 C1.34385546,5.40385714 1.32601139,5.59478571 1.32601139,5.78571429 C1.32601139,5.97664286 1.34385546,6.16757143 1.36764755,6.35271429 L0.112614859,7.30735714 C-0.000397563466,7.39414286 -0.0301376745,7.55035714 0.041238592,7.67764286 L1.23084304,9.6795 C1.3022193,9.80678571 1.4628159,9.85307143 1.59367239,9.80678571 L3.07472992,9.22821429 C3.38402708,9.45964286 3.71711632,9.65057143 4.07994568,9.79521429 L4.30597052,11.3284286 C4.32381459,11.4672857 4.44872305,11.5714286 4.59742361,11.5714286 L6.9766325,11.5714286 C7.12533305,11.5714286 7.25024152,11.4672857 7.26808558,11.3284286 L7.49411043,9.79521429 C7.85693978,9.65057143 8.19002903,9.45385714 8.49932618,9.22821429 L9.98038371,9.80678571 C10.1171882,9.85885714 10.2718368,9.80678571 10.3432131,9.6795 L11.5328175,7.67764286 C11.6041938,7.55035714 11.5744537,7.39414286 11.4614412,7.30735714 L10.2064086,6.35271429 L10.2064086,6.35271429 Z",
    id: "Mask"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 5.78571429,
    cy: 5.78571429,
    r: 1.28571429
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoContentsSetting);
export default __webpack_public_path__ + "static/media/ico-contents-setting.b02f5425c7e28b3ae3815ba09913c30c.svg";
export { ForwardRef as ReactComponent };